// extracted by mini-css-extract-plugin
export const article = "index-module--article--3aUKg";
export const content = "index-module--content--3BIts";
export const inner = "index-module--inner--1hHid";
export const visual = "index-module--visual--3dc0g";
export const image = "index-module--image--3G9xi";
export const movie = "index-module--movie--dPbq9";
export const block = "index-module--block--2HeOn";
export const half = "index-module--half--2Mu6S";
export const lookbook = "index-module--lookbook--oEN6e";
export const box = "index-module--box--2fY4G";
export const products = "index-module--products--2-42N";
export const button = "index-module--button--y-3Fp";
export const profile = "index-module--profile--1AfB2";
export const backToList = "index-module--back-to-list--1vxHb";